import { createSlice } from '@reduxjs/toolkit'

const initialState = { configurations: {} }

const GeneralSlice = createSlice({
    name: 'generalSlice',
    initialState,
    reducers: {
        getBusinessConfigurations: (state, action) => state,
        setBusinessConfigurations: (state, action) => {
            state.configurations = action.payload
            return state
        },
        updateBusinessConfigurations: (state, action) => state,
    },
})

export const { getBusinessConfigurations,updateBusinessConfigurations , setBusinessConfigurations } = GeneralSlice.actions

const GeneralReducer2 = GeneralSlice.reducer;
export default GeneralReducer2

